export const decodeHtmlCharCodes = (string: string) => {
    const div = document.createElement("div");
    div.innerHTML = string;
    console.log("text content", div.textContent);
    const textContent = div.textContent;
    div.remove();
    return textContent || string;
};
